import base from './base'

export default {
  ...base,
  order_id: {
    type: ['undefined', 'string']
  },
  account_id: {
    type: ['undefined', 'string']
  },
  price: {
    type: ['undefined', 'number']
  },
  final_price: {
    type: ['undefined', 'number']
  },
  discount_price: {
    type: ['undefined', 'number']
  },

  last_state: {
    type: ['undefined', 'number']
  },
  cart: {
    type: ['array'],
    default: () => []
  },
  is_paid: {
    type: ['boolean'],
    default: false
  },
  is_verified: {
    type: ['boolean'],
    default: false
  },
  balance: {
    type: ['undefined', 'number']
  },

}
